export default function ContactSection() {
  return (
    <footer className="relative w-full bg-background-50 py-28 md:py-36 px-10 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-20">
          <div className="lg:w-[40%]">
            <h3 className="text-[42px] font-heading font-bold text-foreground-900 leading-[1.15]">
              Contact
            </h3>

            <p className="mt-8 text-[15px] text-foreground-600 font-body leading-[1.7] max-w-[340px]">
              Reach out to discuss engineering partnerships, project requirements, or technical collaboration opportunities.
            </p>

            <div className="mt-12 space-y-1">
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                Address: 322 Manning Ave
              </p>
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                City: Toronto
              </p>
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                Zip: M6J 2L1
              </p>
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                Country: Canada
              </p>
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                Phone number: +1 4387964401
              </p>
              <p className="text-sm text-foreground-700 font-body leading-[2.2]">
                Email: ceo@vasoftlabs.com
              </p>
            </div>
          </div>

          <div className="lg:w-[60%]">
            <div className="grid grid-cols-3 gap-10">
              <div>
                <h4 className="text-xs text-foreground-500 font-label tracking-[0.15em] uppercase mb-6">
                  Systems
                </h4>
                <div className="space-y-3">
                  <p className="text-sm text-foreground-700 font-body">Architecture</p>
                  <p className="text-sm text-foreground-700 font-body">Scalability</p>
                  <p className="text-sm text-foreground-700 font-body">Maintainability</p>
                </div>
              </div>

              <div>
                <h4 className="text-xs text-foreground-500 font-label tracking-[0.15em] uppercase mb-6">
                  Quality
                </h4>
                <div className="space-y-3">
                  <p className="text-sm text-foreground-700 font-body">Performance</p>
                  <p className="text-sm text-foreground-700 font-body">Optimization</p>
                  <p className="text-sm text-foreground-700 font-body">Stability</p>
                </div>
              </div>

              <div>
                <h4 className="text-xs text-foreground-500 font-label tracking-[0.15em] uppercase mb-6">
                  Process
                </h4>
                <div className="space-y-3">
                  <p className="text-sm text-foreground-700 font-body">Innovation</p>
                  <p className="text-sm text-foreground-700 font-body">Workflow</p>
                  <p className="text-sm text-foreground-700 font-body">Excellence</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t border-background-200/70">
          <p className="text-xs text-foreground-400 font-body">
            &copy; {new Date().getFullYear()} VA Soft Labs LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}